// // src/components/BoardPack/pages/bar_chart.jsx

// import React, { useState, useEffect, useRef } from 'react';
// import { apiCall } from '@/api/apiCall';
// import RevenueChart from '../components/charts/RevenueChart';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import ErrorState from '@/components/common/ErrorStateComponent';
// import { safeParseFloat } from '@/lib/safeParseFloat';
// import { useQueue } from '@/context/QueueContext';

// const calculateMovingAverage = (data, key, period = 2) => {
//   return data.map((item, index) => {
//     if (index < period - 1) return { ...item, [`${key}Avg`]: null };
//     let sum = 0, count = 0;
//     for (let i = 0; i < period; i++) {
//       const val = data[index - i][key];
//        if (val != null && !isNaN(val)) {
//         sum += val;
//         count++;
//       }
//     }
//     const avg = count > 0 ? Math.round(sum / count) : null;
//     return { ...item, [`${key}Avg`]: isNaN(avg) ? null : avg };
//   });
// };

// const BarChart = ({ year = "",month = "",monthNumber = "",contract = "",page = null }) => {
//   const { enqueue } = useQueue();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const hasFetchedRef = useRef(false);

//   useEffect(() => {
//     if (!year || !month || !contract) return;
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, month, contract]);

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await enqueue(() => apiCall("get", "/board-pack/parking-enforcement", {
//         contract: page?.params?.contract,
//         year,
//         month,
//         version: page?.params?.version,
//         data_type: page?.params?.data_type || "all"
//       }));

//       if (!response?.success) {
//         throw new Error(response?.message || "API returned unsuccessful response");
//       }

//       if (response?.success && response?.data) {
//         const transformed = response.data.map(item => ({
//           date: item.date,
//           day: item.day,
//           enforcement: safeParseFloat(item.Enforcement),
//           parking: safeParseFloat(item.Parking)
//         }));

//         const withEnfAvg = calculateMovingAverage(transformed, "enforcement");
//         const finalData = calculateMovingAverage(withEnfAvg, "parking");
//         setData(finalData);
//       }
//     } catch (err) {
//       setError(err.message || "Failed to load data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <LoadingComponent />;
//   if (error) return <ErrorState error={error} onRetry={fetchData} />;

//   const Legend = (
//     <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs md:text-sm mb-2">
//       {page?.LEGEND_CONFIG?.enforcement && (
//         <div className="flex items-center gap-2">
//           <div className="w-10 h-3 rounded bg-[#5B9BD5]" />
//           <span>{page?.LEGEND_CONFIG?.enforcement?.label}</span>
//         </div>
//       )}
//       {page?.LEGEND_CONFIG?.parking && (
//         <div className="flex items-center gap-2">
//           <div className="w-10 h-3 rounded bg-[#ED7D31]" />
//           <span>{page?.LEGEND_CONFIG?.parking?.label}</span>
//         </div>
//       )}
//       {page?.LEGEND_CONFIG?.enforcementAvg && (
//         <div className="flex items-center gap-2">
//           <div className="w-8 h-1 relative">
//             <div style={{
//               position: 'absolute', top: '-1px', left: 0, width: '100%', height: '4px',
//               backgroundImage: `repeating-linear-gradient(90deg, #5B9BD5 0, #5B9BD5 4px, transparent 4px, transparent 8px)`,
//             }} />
//           </div>
//           <span>{page?.LEGEND_CONFIG?.enforcementAvg?.label}</span>
//         </div>
//       )}
//       {page?.LEGEND_CONFIG?.parkingAvg && (
//         <div className="flex items-center gap-2">
//           <div className="w-8 h-1 relative">
//             <div style={{
//               position: 'absolute', top: '-1px', left: 0, width: '100%', height: '4px',
//               backgroundImage: `repeating-linear-gradient(90deg, #ED7D31 0, #ED7D31 4px, transparent 4px, transparent 8px)`,
//             }} />
//           </div>
//           <span>{page?.LEGEND_CONFIG?.parkingAvg?.label}</span>
//         </div>
//       )}
//     </div>
//   );

//   return (
//     <RevenueChart
//       title={page?.title ?? ""}
//       subTitle={page?.subtitle ?? ""}
//       graphTitle={page?.in_chart_content_line_1 ?? ""}
//       data={data}
//       loading={loading}
//       error={error}
//       datasetsConfig={page?.datasetsConfig}
//       tableConfig={page?.tableConfig}
//       customLegend={Legend}
//       year={year}
//       centerBaseline={true}  
//     />
//   );
// };

// export default BarChart;



import React, { useState, useEffect, useRef } from 'react';
import { apiCall } from '@/api/apiCall';
import RevenueChart from '../components/charts/RevenueChart';
import LoadingComponent from '@/components/common/LoadingComponent';
import ErrorState from '@/components/common/ErrorStateComponent';
import { safeParseFloat } from '@/lib/safeParseFloat';
import { useQueue } from '@/context/QueueContext';
import { processParams } from '../utils/paramsHelper';
import { useNavigate } from 'react-router-dom';

const calculateMovingAverage = (data, key, period = 2) => {
  return data.map((item, index) => {
    if (index < period - 1) return { ...item, [`${key}Avg`]: null };
    let sum = 0, count = 0;
    for (let i = 0; i < period; i++) {
      const val = data[index - i][key];
      if (val != null && !isNaN(val)) {
        sum += val;
        count++;
      }
    }
    const avg = count > 0 ? Math.round(sum / count) : null;
    return { ...item, [`${key}Avg`]: isNaN(avg) ? null : avg };
  });
};

const BarChart = ({ year = "", month = "", monthNumber = "", contract = "", page = null, isRefresh = false }) => {
  const { enqueue } = useQueue();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!year || !month || !contract) return;
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchData();
  }, [year, month, contract]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const apiParams = processParams(page?.params || {}, { year, month, contract });

      const response = await enqueue(() => apiCall("get", "/board-pack/parking-enforcement", apiParams,navigate,false,false,isRefresh));

      if (!response?.success) {
        throw new Error(response?.message || "API returned unsuccessful response");
      }

      if (response?.success && response?.data) {
        const transformed = response.data.map(item => ({
          date: item.date,
          day: item.day,
          enforcement: safeParseFloat(item.Enforcement),
          parking: safeParseFloat(item.Parking)
        }));

        const withEnfAvg = calculateMovingAverage(transformed, "enforcement");
        const finalData = calculateMovingAverage(withEnfAvg, "parking");
        setData(finalData);
      }
    } catch (err) {
      setError(err.message || "Failed to load data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={fetchData} />;

  const Legend = (
    <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs md:text-sm mb-2">
      {page?.LEGEND_CONFIG?.enforcement && (
        <div className="flex items-center gap-2">
          <div className="w-10 h-3 rounded bg-[#5B9BD5]" />
          <span>{page?.LEGEND_CONFIG?.enforcement?.label}</span>
        </div>
      )}
      {page?.LEGEND_CONFIG?.parking && (
        <div className="flex items-center gap-2">
          <div className="w-10 h-3 rounded bg-[#ED7D31]" />
          <span>{page?.LEGEND_CONFIG?.parking?.label}</span>
        </div>
      )}
      {page?.LEGEND_CONFIG?.enforcementAvg && (
        <div className="flex items-center gap-2">
          <div className="w-8 h-1 relative">
            <div style={{
              position: 'absolute', top: '-1px', left: 0, width: '100%', height: '4px',
              backgroundImage: `repeating-linear-gradient(90deg, #5B9BD5 0, #5B9BD5 4px, transparent 4px, transparent 8px)`,
            }} />
          </div>
          <span>{page?.LEGEND_CONFIG?.enforcementAvg?.label}</span>
        </div>
      )}
      {page?.LEGEND_CONFIG?.parkingAvg && (
        <div className="flex items-center gap-2">
          <div className="w-8 h-1 relative">
            <div style={{
              position: 'absolute', top: '-1px', left: 0, width: '100%', height: '4px',
              backgroundImage: `repeating-linear-gradient(90deg, #ED7D31 0, #ED7D31 4px, transparent 4px, transparent 8px)`,
            }} />
          </div>
          <span>{page?.LEGEND_CONFIG?.parkingAvg?.label}</span>
        </div>
      )}
    </div>
  );

  return (
    <RevenueChart
      title={page?.title ?? ""}
      subTitle={page?.subtitle ?? ""}
      graphTitle={page?.in_chart_content_line_1 ?? ""}
      data={data}
      loading={loading}
      error={error}
      datasetsConfig={page?.datasetsConfig}
      tableConfig={page?.tableConfig}
      customLegend={Legend}
      year={year}
      centerBaseline={true}
      version={page?.params?.version ?? ""}  // ✅ version prop pass kiya
    />
  );
};

export default BarChart;